"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const testimonials = [{
    id: 1,
    quote: "Greg and his team have been selling our development projects since 2009 and I wouldn’t trust anyone else. They have been invaluable in helping us to find projects, figuring out the product type that makes sense to build and then in selling the final product. They are professional all the way through and act much more like invested partners than traditional brokers.\xA0",
    name: "Mike Knepp",
    title: "CEO Knepp Inc."
  }, {
    id: 2,
    quote: "Greg and his team get the job done and seem to be able to handle the most difficult situations. I’ve been working with them for years and will continue to use them as my go to brokers for both my commercial and residential projects.",
    name: "Francisco Choi, AIA",
    title: "FTC Architects, PC"
  }, {
    id: 3,
    quote: "Working with DealForge elevated our entire approach to real estate investment. Their strategic insights and execution excellence are unmatched in the industry.",
    name: "David Morrison",
    title: "CEO, Vertex Real Estate Ventures"
  }, {
    id: 4,
    quote: "Greg and his team get the job done and seem to be able to handle the most difficult situations. I’ve been working with them for years and will continue to use them as my go to brokers for both my commercial and residential projects.",
    name: "Francisco Choi, AIA - NCARB",
    title: "FTC Architects, PC"
  }, {
    id: 5,
    quote: "The strategic depth DealForge brings to land acquisition and development is truly impressive. They are our first call for any new project and have become an essential part of our growth strategy.",
    name: "Anonymous",
    title: "Client"
  }];
  return <section id="testimonials" className="bg-background py-20 md:py-28 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={`text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-color-primary mb-4">CLIENT TESTIMONIALS</h2>
          <p className="text-color-muted max-w-2xl mx-auto text-lg">
            Trusted by developers, investors, and landowners across residential
            and commercial markets.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/2">
                  <Card className="h-full border border-color-border hover:border-color-accent transition-all duration-300">
                    <CardContent className="flex flex-col h-full p-8 gap-6">
                      <Quote className="size-10 text-color-accent opacity-50" />
                      <blockquote className="text-color-foreground text-base leading-relaxed flex-grow">
                        "{testimonial.quote}"
                      </blockquote>
                      <div className="border-t border-color-border pt-4">
                        <p className="font-semibold text-color-primary mb-1">
                          {testimonial.name}
                        </p>
                        <p className="text-sm text-color-muted-foreground">
                          {testimonial.title}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-16 bg-background border-color-border hover:bg-color-accent hover:text-foreground hover:border-color-accent transition-all duration-300" />
            <CarouselNext className="hidden md:flex -right-16 bg-background border-color-border hover:bg-color-accent hover:text-foreground hover:border-color-accent transition-all duration-300" />
          </Carousel>
        </div>
      </div>
    </section>;
}